/* ==========================================================================
   Mui ten trai/phai tren ANH CHINH cua trang san pham (chi may tinh).

   Theme co san hai nut nhung gan class desktop-hidden, va tren may tinh no
   chi hien dung anh dang chon (:not(.is-active){display:none}) nen truot
   ngang khong co tac dung.

   Cach chac an nhat: bam ho cai thumbnail ke tiep — theme tu goi
   setActiveMedia nhu khi nguoi dung bam tay. Khong phai gianh viec voi JS
   cua theme, nen khong hong khi theme ve lai danh sach.

   (Cot thumbnail doc khong co nut — cuon bang con lan chuot.)
   ========================================================================== */
(function () {
  "use strict";

  /* Chep y nguyen mui ten cua seensense (.flickityt4s-button-icon):
     mui ten DAC, viewBox 100x100, to mau bang currentcolor.
     Huong mac dinh la chi TRAI nen nut "sau" xoay 180 do. */
  var CHEVRON =
    '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z"/>' +
    '</svg>';

  function laMayTinh() {
    return window.matchMedia("(min-width: 990px)").matches;
  }

  function taoNut(huong) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "kls-main-btn kls-main-btn--" + (huong < 0 ? "truoc" : "sau");
    b.setAttribute("aria-label", huong < 0 ? "Anh truoc" : "Anh tiep theo");
    b.innerHTML = CHEVRON;
    return b;
  }

  /* Chi tinh nhung thumbnail dang thuc su hien (theme loc anh theo mau) */
  function thumbHien(gallery) {
    var list = gallery.querySelector(".thumbnail-list");
    if (!list) return [];
    return [].slice.call(list.children).filter(function (i) {
      return i.getBoundingClientRect().height > 0;
    });
  }

  function viTriDangChon(ds) {
    for (var i = 0; i < ds.length; i++) {
      var n = ds[i].querySelector("[aria-current]");
      if (n && n.getAttribute("aria-current") === "true") return i;
    }
    return 0;
  }

  function doiAnh(gallery, huong) {
    var ds = thumbHien(gallery);
    if (ds.length < 2) return;
    var i = viTriDangChon(ds) + huong;
    if (i < 0 || i >= ds.length) return;
    var nut = ds[i].querySelector("button, a");
    if (!nut) return;
    nut.click();
    /* Keo cot thumbnail cho anh dang chon nam trong tam nhin.
       KHONG dung scrollIntoView: no cuon ca TRANG chu khong rieng cot,
       lam ca khung anh nhay len xuong. Tu cuon dung cai cot. */
    keoCotVaoTamNhin(gallery, ds[i]);
    setTimeout(function () {
      gan(gallery);
    }, 80);
  }

  /* Neo nut theo MEP ANH THAT, khong phai theo khung GalleryViewer.

     Ly do: khi cua so THAP, theme gioi han chieu cao anh nen anh hep lai va
     co vao giua khung, chua khoang trang hai ben. Neo theo khung thi nut roi
     ra vung trang do (do duoc: cua so cao 720px -> nut nam ngoai anh 72px).
     Khung cung cao hon anh nen top:50% lech xuong duoi tam anh.

     Ghi ra CSS bien de CSS dat vi tri. Chi ghi khi gia tri doi that (>1px)
     nen doi anh khong sinh ra thay doi nao -> nut khong nhay. */
  var THUT = 15; /* seensense thut 15px so voi mep anh */

  /* Khoang lech cua mot phan tu so voi to tien, tinh bang offsetLeft/offsetTop.
     KHONG dung getBoundingClientRect: luc theme doi anh no cuon ngang danh
     sach, lam rect nhay lung tung (do duoc X nhay 242 -> 771 -> 833 -> -349).
     offsetLeft/offsetTop khong phu thuoc vao cuon nen luon on dinh. */
  function lechTrong(el, toTien) {
    var x = 0, y = 0, n = el;
    while (n && n !== toTien) {
      x += n.offsetLeft;
      y += n.offsetTop;
      n = n.offsetParent;
    }
    return n === toTien ? { x: x, y: y } : null;
  }

  function datViTriNut(gallery) {
    var v = gallery.querySelector('[id^="GalleryViewer"]');
    if (!v) return;
    var img = v.querySelector(".product__media-item.is-active img");
    if (!img || !img.offsetWidth || !img.offsetHeight) return;
    var lech = lechTrong(img, v);
    if (!lech) return;

    var leTrai = lech.x + THUT;
    var lePhai = v.offsetWidth - (lech.x + img.offsetWidth) + THUT;
    /* chan gia tri vo ly (anh chua bay xong bo cuc) */
    if (leTrai < 0 || lePhai < 0 || leTrai > v.offsetWidth / 2) return;

    ghiBien(gallery, "--kls-le-trai", leTrai);
    ghiBien(gallery, "--kls-le-phai", lePhai);
    ghiBien(gallery, "--kls-tam-anh", lech.y + img.offsetHeight / 2);
  }

  function ghiBien(el, ten, giaTri) {
    var moi = Math.round(giaTri);
    var cu = parseFloat(el.style.getPropertyValue(ten));
    if (!isNaN(cu) && Math.abs(cu - moi) <= 1) return; /* khong doi -> khong ghi */
    el.style.setProperty(ten, moi + "px");
  }

  function keoCotVaoTamNhin(gallery, o) {
    var list = gallery.querySelector(".thumbnail-list");
    if (!list || !o) return;
    var a = o.getBoundingClientRect();
    var k = list.getBoundingClientRect();
    if (a.top < k.top) {
      list.scrollBy({ top: a.top - k.top, behavior: "smooth" });
    } else if (a.bottom > k.bottom) {
      list.scrollBy({ top: a.bottom - k.bottom, behavior: "smooth" });
    }
  }

  function capNhat(gallery, truoc, sau) {
    datViTriNut(gallery);
    var ds = thumbHien(gallery);
    var du = laMayTinh() && ds.length > 1;
    gallery.classList.toggle("kls-co-mui-ten", du);
    if (!du) return;
    var i = viTriDangChon(ds);
    truoc.classList.toggle("kls-main-btn--tat", i <= 0);
    sau.classList.toggle("kls-main-btn--tat", i >= ds.length - 1);
  }

  function gan(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    var truoc = gallery.querySelector(".kls-main-btn--truoc");
    var sau = gallery.querySelector(".kls-main-btn--sau");
    if (!truoc) {
      truoc = taoNut(-1);
      sau = taoNut(1);
      viewer.appendChild(truoc);
      viewer.appendChild(sau);
      truoc.addEventListener("click", function () {
        doiAnh(gallery, -1);
      });
      sau.addEventListener("click", function () {
        doiAnh(gallery, 1);
      });
      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          datViTriNut(gallery);
        }).observe(viewer);
      }
    }
    capNhat(gallery, truoc, sau);
  }

  function chay() {
    document
      .querySelectorAll(".product__media-wrapper media-gallery")
      .forEach(gan);
  }

  document.addEventListener("DOMContentLoaded", chay);
  document.addEventListener("shopify:section:load", chay);
  window.addEventListener("resize", function () {
    clearTimeout(window.__klsNavT);
    window.__klsNavT = setTimeout(chay, 200);
  });
  /* Doi mau -> theme ve lai danh sach thumbnail */
  var host = document.querySelector(".product__media-wrapper");
  if (host) {
    new MutationObserver(function () {
      setTimeout(chay, 60);
    }).observe(host, { childList: true, subtree: true });
  }
})();
